import { useCallback } from "react";
import useMembership from "@/shared/hooks/useMembership";

// 전달서 §15 — BASIC 기능으로 48시간, 계정당 1회.
export const FREE_TRIAL_HOURS = 48;

/**
 * 무료체험 대상 판정.
 *
 * 사상 첫 결제 대상(멤버십 없음 + 신청 이력 없음)에게만 프로모션을 띄운다.
 * 신청 API 가 아직 없어 시작 시각은 브라우저 저장소에만 남기고 대상 판정에는 쓰지 않는다 —
 * 저장소는 지울 수 있어서 "계정당 1회" 집행은 나중에 서버가 맡아야 한다(전달서 §26).
 */
export default function useStartGuideFreeTrial(
  onStart: (startedAtIso: string) => void
) {
  const { isFirstPathPickPayment } = useMembership();

  const start = useCallback(() => {
    onStart(new Date().toISOString());
  }, [onStart]);

  return { isEligible: isFirstPathPickPayment, start };
}
